module.exports = __webpack_public_path__ + "static/media/og02.aa4b9947.webp";